var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineWatchStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 19.75c-2.74 0-4.25-1.51-4.25-4.25v-7c0-2.74 1.51-4.25 4.25-4.25h7c2.74 0 4.25 1.51 4.25 4.25v7c0 2.74-1.51 4.25-4.25 4.25h-7zM5.75 8.5v7c0 1.93.82 2.75 2.75 2.75h7c1.93 0 2.75-.82 2.75-2.75v-7c0-1.93-.82-2.75-2.75-2.75h-7c-1.93 0-2.75.82-2.75 2.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 2.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8c.41 0 .75.34.75.75s-.34.75-.75.75H8zM8 22.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8c.41 0 .75.34.75.75s-.34.75-.75.75H8zM11.25 14v-4c0-.41.34-.75.75-.75s.75.34.75.75v4a.749.749 0 1 1-1.5 0zM14.25 14v-2c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .42-.33.75-.75.75-.41 0-.75-.34-.75-.75zM8.25 14v-1c0-.41.34-.75.75-.75s.75.34.75.75v1a.749.749 0 1 1-1.5 0z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineWatchStatus);
export default __webpack_public_path__ + "static/media/vuesax-outline-watch-status.6f990340c6e12af814e076cab9c583e3.svg";
export { ForwardRef as ReactComponent };